// src/theme.ts
import { theme } from 'antd';
import type { ThemeConfig } from 'antd/es/config-provider/context';

export const darkTheme: ThemeConfig = {
  algorithm: theme.darkAlgorithm,
  token: {
    colorPrimary: '#854eca', // <- 👈 this sets the underline and hover glow to purple
    colorBgBase: '#000000',
    colorTextBase: '#ffffff',
  },
};

export const lightTheme: ThemeConfig = {
  algorithm: theme.defaultAlgorithm,
  token: {
    colorPrimary: '#854eca',
    colorBgBase: '#ffffff',
    colorTextBase: '#000000',
  },
};
